import React from 'react';
import { Stack, TextField } from '@mui/material';
import type { FeatureFlagMetadataFormProps } from '../../../types/features/featureFlags';

const FeatureFlagMetadataForm: React.FC<FeatureFlagMetadataFormProps> = ({
  fieldErrors = {},
  mode,
  onFieldChange,
  values,
}) => {
  const isUpdateMode = mode === 'update';

  return (
    <Stack spacing={1.5}>
      <TextField
        fullWidth
        label="Feature Name"
        margin="dense"
        value={values.displayName}
        error={Boolean(fieldErrors.displayName)}
        helperText={fieldErrors.displayName}
        onChange={(event) => onFieldChange('displayName', event.target.value)}
        sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#ffffff', borderRadius: '8px' } }}
      />
      <TextField
        fullWidth
        disabled={isUpdateMode}
        error={Boolean(fieldErrors.featureKey)}
        helperText={fieldErrors.featureKey || (isUpdateMode ? 'Feature key cannot be changed after creation.' : undefined)}
        label="Feature Key"
        margin="dense"
        value={values.featureKey}
        onChange={(event) => onFieldChange('featureKey', event.target.value)}
        sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#ffffff', borderRadius: '8px' } }}
      />
      <TextField
        fullWidth
        multiline
        minRows={4}
        label="Description"
        margin="dense"
        value={values.description}
        error={Boolean(fieldErrors.description)}
        helperText={fieldErrors.description}
        onChange={(event) => onFieldChange('description', event.target.value)}
        sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#ffffff', borderRadius: '8px' } }}
      />
    </Stack>
  );
};

export default React.memo(FeatureFlagMetadataForm);
